import React from 'react';
import { Card, CardContent, Typography, Box, Stack, Skeleton, alpha, useTheme } from '@mui/material';
import TrendingUpIcon from '@mui/icons-material/TrendingUp';
import { ArrowDropDown, ArrowDropUp } from '@mui/icons-material';

const StatCard = ({ title, value, icon, loading, color = 'primary', percentage = false, positiveTrend = false, negativeTrend = false, decimals=1 }) => {
  const theme = useTheme();

  const formatValue = (val) => {
    if (val === null || val === undefined) return '0';
    const num = typeof val === 'string' ? parseFloat(val) : val;
    
    // If it's a valid number and has decimals, format it
    return Number.isInteger(num) ? num : num.toFixed(decimals);
  };
  
  return (
    <Card variant="outlined" sx={{ height: '100%' }}>
      <CardContent>
        <Stack direction="row" justifyContent="space-between" alignItems="flex-start">
          <Box>
            <Stack direction="row" alignItems="center" spacing={0.5}>
              <Typography variant="overline" color="text.secondary" fontWeight={700}>
                {title}
              </Typography>
              
              {/* Render Trend Icons */}
              {positiveTrend && <ArrowDropUp color="success" />}
              {negativeTrend && <ArrowDropDown color="error" />}
            </Stack>
            {loading ? (
              <Skeleton width={80} height={40} />
            ) : (
              <Typography variant="h4" fontWeight={800} sx={{ mt: 1 }}>
                {formatValue(value)} {percentage ? "%" : null}
              </Typography>
            )}
          </Box>
          <Box sx={{ 
            p: 1.5, 
            borderRadius: 2,
            bgcolor: alpha(theme.palette[color].main, 0.1),
            color: theme.palette[color].main 
          }}>
            {icon}
          </Box>
        </Stack>
      </CardContent>
    </Card>
  );
};

export default StatCard;